// extracted by mini-css-extract-plugin
export var hero = "project-archive-module--hero--DJ2LB";
export var heroContainer = "project-archive-module--heroContainer--QB7kW";
export var heroColumn = "project-archive-module--heroColumn--J5hRt";
export var filterColumn = "project-archive-module--filterColumn--n81jo";
export var filterItem = "project-archive-module--filterItem--FJ-mQ";
export var uppercase = "project-archive-module--uppercase--D0Xad";
export var projectsWrapper = "project-archive-module--projectsWrapper--+RsxE";
export var projectsContainer = "project-archive-module--projectsContainer--tINyG";